import { Box } from '@mui/material';

import { AdminMessenger } from '@/components/Admin/Messenger/AdminMessenger';

export const AdminFeedback = () => {
  return (
    <Box>
      <AdminMessenger />
    </Box>
  );
};
